import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)


import Home from '@/views/home/index.vue'
import Login from '@/views/login/login.vue'
import Register from '@/views/register/register.vue'
import Contact from '@/views/contact/contact.vue'
import Privacy from '@/views/legal/PrivacyPolicy.vue'
import Terms from '@/views/legal/TermsOfService.vue'
import Search from '@/views/search/search.vue'
import Details from '@/views/video/details/details.vue'
import Member from '@/views/user/member/member.vue'
import Favorite from '@/views/user/favorite/favorite.vue'
import History from '@/views/user/history/history.vue'
import Order from '@/views/user/order/order.vue'
import Subscription from '@/views/user/subscription/subscription.vue'
import Recharge from '@/views/recharge/recharge.vue'
import Category from '@/views/video/category/category.vue'
import Settings from '@/views/settings/settings.vue'
import EditProfile from '@/views/settings/EditProfile.vue'
import ChangePassword from '@/views/settings/ChangePassword.vue'
import Checkout from '@/views/checkout/checkout.vue'

// 定义路由
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/base/login',
    name: 'Login',
    component: Login,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/base/register',
    name: 'Register',
    component: Register,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/legal/terms',
    name: 'Terms',
    component: Terms,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/legal/privacy',
    name: 'Privacy',
    component: Privacy,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/search/search',
    name: 'Search',
    component: Search,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/video/details/details',
    name: 'Details',
    component: Details,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/user/member/member',
    name: 'Member',
    component: Member,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/user/favorite/favorite',
    name: 'Favorite',
    component: Favorite,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/user/history/history',
    name: 'History',
    component: History,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/user/order/order',
    name: 'Order',
    component: Order,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/user/subscription/subscription',
    name: 'Subscription',
    component: Subscription,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/user/recharge/recharge',
    name: 'Recharge',
    component: Recharge,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/user/category/category',
    name: 'Category',
    component: Category,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/contact/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/settings/settings',
    name: 'Settings',
    component: Settings,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/settings/edit-profile',
    name: 'EditProfile',
    component: EditProfile,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/settings/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/checkout/checkout',
    name: 'Checkout',
    component: Checkout,
    meta: {
      keepAlive: false
    }
  }
]

// 创建路由实例
const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
